export const UNLIMITED_TIER_NUMBER = 0;
